import { render, staticRenderFns } from "./videoTest.vue?vue&type=template&id=0504bff7&"
import script from "./videoTest.vue?vue&type=script&lang=js&"
export * from "./videoTest.vue?vue&type=script&lang=js&"
import style0 from "./videoTest.vue?vue&type=style&index=0&id=0504bff7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports